import { Crown, X, Sparkles, Star, UserRound, Check } from "lucide-react";
import perfilExemplo from "../../assets/perfilteste.webp";
import "./GoldOnboardingModal.scss";

const IconStar = ({ filled }) => (
  <Star
    size={14}
    strokeWidth={1.8}
    fill={filled ? "currentColor" : "none"}
  />
);

export default function GoldOnboardingModal({ onClose, trialWelcome = false }) {
  // Dados mockados para a prévia
  const mockProfile = {
    name: "João Silva",
    avatarUrl: perfilExemplo,
    isGold: true,
  };

  const displayName = mockProfile.name;
  const initials = displayName
    .split(" ")
    .slice(0, 2)
    .map((name) => name[0])
    .join("")
    .toUpperCase();

  return (
    <div className="gold-onboarding-overlay">
      <div className={`gold-onboarding-modal ${trialWelcome ? "gold-onboarding-modal--welcome" : ""}`}>
        <button
          type="button"
          className="gold-onboarding-close"
          onClick={onClose}
          aria-label="Fechar"
        >
          <X size={20} />
        </button>

        {/* ====================================================== */}
        {/* CONTEÚDO DO ONBOARDING */}
        {/* ====================================================== */}
        <div className="gold-onboarding-content">
          {trialWelcome ? (
            <>
              <span className="gold-onboarding-eyebrow">
                <Sparkles size={14} />
                BEM-VINDO À PLATAFORMA
              </span>

              <h2>Você ganhou Gold por 7 dias!</h2>

              <p>
                Aproveite seu período Gold e tenha acesso a:
              </p>

              <ul className="gold-onboarding-benefits">
                <li>
                  <Check size={18} />
                  <span>Novas vagas no instante em que são criadas, sem delay.</span>
                </li>
                <li>
                  <Check size={18} />
                  <span>Perfil em destaque para as empresas.</span>
                </li>
              </ul>
            </>
          ) : (
            <>
          <span className="gold-onboarding-eyebrow">
            <Sparkles size={14} />
            DESTAQUE PREMIUM
          </span>

          <h2>
            Seu perfil em evidência
            <br />
            para as grandes empresas!
          </h2>

          {/* ====================================================== */}
          {/* PRÉ-VISUALIZAÇÃO EXATA DO HEADER GOLD */}
          {/* ====================================================== */}
          <div className="gold-preview-wrapper">
            <span className="gold-preview-label">
              Visão da Empresa ao receber sua candidatura:
            </span>

            {/* Header miniaturizado igual ao CompanyViewFreelancerModal */}
            <div className="gold-preview-header">
              {/* Avatar com moldura dourada */}
              <div className="gold-preview-avatar-wrapper gold-preview-avatar-wrapper--gold">
                {mockProfile.avatarUrl ? (
                  <img
                    src={mockProfile.avatarUrl}
                    alt={displayName}
                    className="gold-preview-avatar"
                  />
                ) : (
                  <div className="gold-preview-avatar-fallback">{initials}</div>
                )}

                {/* Coroa no avatar (igual ao cvf-avatar-crown) */}
                <span className="gold-preview-avatar-crown">
                  <Crown size={12} fill="currentColor" />
                </span>
              </div>

              {/* Informações do header */}
              <div className="gold-preview-header-info">
                <div className="gold-preview-name-row">
                  <h3 className="gold-preview-name">{displayName}</h3>

                  {/* Badge Gold igual ao cvf-plan-badge */}
                  <span className="gold-preview-plan-badge">
                    <Crown size={12} fill="currentColor" />
                    Gold
                  </span>
                </div>

                {/* Label "Freelancer" igual ao cvf-profile-label */}
                <div className="gold-preview-profile-label">
                  <UserRound size={12} />
                  Freelancer
                </div>

                {/* Rating com estrelas igual ao cvf-rating */}
                <div className="gold-preview-rating">
                  <div className="gold-preview-stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <IconStar key={star} filled={star <= 4} />
                    ))}
                  </div>

                  <strong>4.7</strong>

                  <span className="gold-preview-rating-count">
                    3 avaliações
                  </span>
                </div>
              </div>
            </div>

            {/* Selo "Em Destaque" abaixo do header */}
            <div className="gold-preview-highlight-tag">
              <Star size={12} fill="currentColor" />
              <span>Em Destaque</span>
            </div>
          </div>

          <p>
            Com o <strong>Gold</strong>, suas candidaturas ganham superpoderes, aparecem com o selo de destaque e ficam no topo para os recrutadores.
          </p>

          <div className="gold-onboarding-hint">
            <div className="gold-onboarding-hint-icon">
              <Crown size={18} fill="currentColor" />
            </div>

            <div>
              <strong>Como ativar agora?</strong>
              <span>
                Clique no selo <b>Gold/Free</b> localizado no topo do seu perfil principal para desbloquear.
              </span>
            </div>
          </div>
            </>
          )}
        </div>

        <button
          type="button"
          className="gold-onboarding-button"
          onClick={onClose}
        >
          {trialWelcome ? "Começar a aproveitar" : "Entendi"}
        </button>
      </div>
    </div>
  );
}